// import * as file from './data-file'
// import * as json from './data-json'
import * as restRequest from './request/rest-request';
import * as defaultRequest from './request/default-request';
function fetch(type, config){
    return new Promise((r, rj)=>{
        let promise = null;
        if(type==='data-rest'){
            promise = restRequest.fetch(config)
        }else if(type==='data-default'){
            promise = defaultRequest.fetch(config)
        }
        if(promise){
            promise.then((data)=>{
                r(data);
            }).catch(e=>{
                console.error(e);
                rj(e);
            });
        }else{
            r(config);
        }
    });
}

function createOrUpdate(data, params) {
    return new Promise((r, rj)=>{
        let promise = null;
        if(type==='data-default'){
            promise = defaultRequest.createOrUpdate(data, params)
        }
        if(promise){
            promise.then((data)=>{
                r(data);
            }).catch(e=>{
                console.error(e);
                rj(e);
            });
        }else{
            r(config);
        }
    });
}

export {fetch, createOrUpdate}